export default "__VITE_ASSET__BRldFpE0__"